// src/components/store/sections/newsletter/NewsletterV87BentosignupCrimsonRose.tsx
"use client";

import React from "react";
import DynamicNewsletterVariant from "./DynamicNewsletterVariant";

export default function NewsletterV87BentosignupCrimsonRose(props: any) {
  return (
    <DynamicNewsletterVariant
      variantNumber={87}
      archKey="bento_signup"
      archLabel="Bento Multi-Tile Signup"
      palName="CrimsonRose"
      grad="from-rose-500 via-pink-600 to-red-600"
      lightBg="bg-rose-50"
      textCol="text-rose-700"
      borderCol="border-rose-200"
      btnCls="bg-rose-600 hover:bg-rose-700"
      hexCol="#f43f5e"
      {...props}
    />
  );
}
